/**
 * Dashboard URL 导航协议常量
 *
 * URL 结构约定：
 *   /platform/new_dashboard?type=campaign&ac_id=890&c_id=123&startDate=20260617&endDate=20260618&timezone=UTC%2B8&latitude=1
 *
 * 参数分两组：
 * - 层级参数：type + ac_id + c_id，决定展示哪一层数据
 * - 筛选参数：startDate / endDate / timezone / latitude，决定数据的时间与粒度范围
 *
 * session key 格式：`${用户email}_${后缀}`，确保多用户共享浏览器时互不干扰
 */

/** Dashboard 路由 path（不含 query） */
export const DASHBOARD_PATH = '/platform/new_dashboard';

/**
 * URL query 参数名映射
 * 与 vue-router this.$route.query 的 key 一一对应
 */
export const QUERY_KEYS = {
    /** 层级类型：account（全部账户） | campaign（单账户下的广告计划） | ad（广告列表） */
    TYPE: 'type',
    /** 账户 ID，多账户时逗号分隔（目前暂不支持多账户） */
    ACCOUNT_ID: 'ac_id',
    /** Campaign ID，多选进入 ad 层时逗号分隔 */
    CAMPAIGN_ID: 'c_id',
    /** 起始日期（天模式 YYYYMMDD / 小时模式 YYYYMMDDHH） */
    START_DATE: 'startDate',
    /** 截止日期（格式同 startDate） */
    END_DATE: 'endDate',
    /** 时区（如 UTC+8），URL 中经 encodeURIComponent 编码 */
    TIMEZONE: 'timezone',
    /** 时间粒度：'1' = 按天，'2' = 按小时 */
    LATITUDE: 'latitude'
};

/** Dashboard sessionStorage key 后缀 */
export const DASHBOARD_SESSION_KEY_SUFFIX = 'msn_new_dashboard_ctx';

/** 创建广告页 sessionStorage key 后缀 */
export const CAMPAIGN_CREATE_SESSION_KEY_SUFFIX = 'msn_campaign_create_ctx';
